<script setup>
import { onMounted } from 'vue';

// HybsChat patch: las cuentas suspendidas se gestionan en el portal WHMCS.
// Redirige automáticamente (sin esperar un refresh manual) usando el
// account_id presente en la URL /app/accounts/:id/suspended.
onMounted(() => {
  const match = window.location.pathname.match(/accounts\/(\d+)\/suspended/);
  const accountId = match ? match[1] : '';
  window.location.replace(
    `https://my.hybschat.com/suspendido.php?cw_account=${accountId}`
  );
});
</script>

<template>
  <div
    class="items-center bg-n-slate-2 flex justify-center h-full w-full text-n-slate-11"
  >
    Redirigiendo a tu portal…
  </div>
</template>
